import { render, staticRenderFns } from "./LoadsTr.vue?vue&type=template&id=708a6cac&scoped=true"
import script from "./LoadsTr.vue?vue&type=script&lang=js"
export * from "./LoadsTr.vue?vue&type=script&lang=js"
import style0 from "./LoadsTr.vue?vue&type=style&index=0&id=708a6cac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a6cac",
  null
  
)

export default component.exports